import { getRgObjectsOfType as e, RG_TYPE as o } from "@project-rouge/rg-core";
import { queryPivot as r } from "../../../utils/index25.js";
const g = (i) => {
  const n = e(i, o.Apartment)[0], t = e(n, o.Module)[0], l = r({ obj: t, type: o.Floor, pivot: [0, 1, 0] }).y;
  return r({ obj: t, type: o.Ceiling, pivot: [0, 0, 0] }).y - l;
};
export {
  g as getClearInternalHeight
};
//# sourceMappingURL=index10.js.map
